export const MEASUREMENT_CONSENT_COOKIE_NAME = 'oil_GTM_cookie';

export const hasMeasurementConsentInCookieValue = (cookieValue: string | undefined) =>
  !!cookieValue && decodeURIComponent(cookieValue).includes('"5":true');
